import { BaseAbstractService } from "@common/service/base-service/global";
import RequestService from "@common/service/base-service/request/ICT2BRequest";
import { CollegesApi } from "@/zh-website/src/views/Colleges/api";
import { DelistDto } from "@/zh-website/src/views/Colleges/model/interface";

export class CollegesService extends BaseAbstractService {
  static checkEmployeeDelisting(data: DelistDto) {
    return CollegesApi.checkEmployeeDelisting(this.request, data).then(res => {
      return res.data ? res.data : false;
    });
  }
  static getTrainingNewsList(query) {
    //query {typeList:1 2 3} 类型：1：政企 2：高校 3：合作伙伴
    return CollegesApi.getTrainingNewsList(this.request, query);
  }
  static getProductSolutionList(query) {
    return CollegesApi.getProductSolutionList(this.request, query);
  }
  static getProductCaseList(query) {
    return CollegesApi.getProductCaseList(this.request, query);
  }
  static getProductSolutionDetail(query) {
    return CollegesApi.getProductSolutionDetail(this.request, query);
  }
  //college cases
  static getCollegeCaseList(query) {
    return CollegesApi.getCollegeCaseList(this.request, query);
  }

  //education cooperation
  static getCooperationList(query) {
    return CollegesApi.getCooperationList(this.request, query);
  }
}
CollegesService.setRequest(RequestService);
